var _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 65,
    viewBox: "0 0 200 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.39543 0.89543 0.5 2 0.5H39C40.1046 0.5 41 1.39543 41 2.5V14.5C41 15.6046 40.1046 16.5 39 16.5H2C0.895431 16.5 0 15.6046 0 14.5V2.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 2.5C49 1.39543 49.8954 0.5 51 0.5H198C199.105 0.5 200 1.39543 200 2.5V14.5C200 15.6046 199.105 16.5 198 16.5H51C49.8954 16.5 49 15.6046 49 14.5V2.5Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.5C0 25.3954 0.89543 24.5 2 24.5H39C40.1046 24.5 41 25.3954 41 26.5V38.5C41 39.6046 40.1046 40.5 39 40.5H2C0.895431 40.5 0 39.6046 0 38.5V26.5Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26.5C49 25.3954 49.8954 24.5 51 24.5H198C199.105 24.5 200 25.3954 200 26.5V38.5C200 39.6046 199.105 40.5 198 40.5H51C49.8954 40.5 49 39.6046 49 38.5V26.5Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 50.5C0 49.3954 0.89543 48.5 2 48.5H39C40.1046 48.5 41 49.3954 41 50.5V62.5C41 63.6046 40.1046 64.5 39 64.5H2C0.895431 64.5 0 63.6046 0 62.5V50.5Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50.5C49 49.3954 49.8954 48.5 51 48.5H198C199.105 48.5 200 49.3954 200 50.5V62.5C200 63.6046 199.105 64.5 198 64.5H51C49.8954 64.5 49 63.6046 49 62.5V50.5Z",
    fill: "black",
    fillOpacity: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.36220c4efb79d69fb7979560f3da3088.svg";
export { ForwardRef as ReactComponent };